import { formatEmbryoGrade } from "@src/packages/care/cryovault/embryoGrade";
import type { Specimen } from "@src/packages/care/cryovault/useSpecimens";

export type EmbryoDevelopmentObservation = NonNullable<
  Specimen["dayDetails"]
>[number];

export function sortEmbryoDevelopmentObservations(
  details: Specimen["dayDetails"],
): EmbryoDevelopmentObservation[] {
  return [...(details ?? [])].sort((left, right) => left.day - right.day);
}

export function getLatestEmbryoDevelopmentObservation(
  details: Specimen["dayDetails"],
): EmbryoDevelopmentObservation | null {
  const sorted = sortEmbryoDevelopmentObservations(details);
  return sorted.at(-1) ?? null;
}

export function formatEmbryoGradeFromDayDetails(
  details: Specimen["dayDetails"],
): string | null {
  const detail = getLatestEmbryoDevelopmentObservation(details);
  return detail ? formatEmbryoGrade(detail) : null;
}
